// extracted by mini-css-extract-plugin
module.exports = {"reminder":"index_reminder__38GiL","reminder_title":"index_reminder_title__3quc6","reminder_content":"index_reminder_content__1YglW"};